import GridView from "../../components/controls/GridView/GridView";
import customerService, { Customer } from "../../services/customerService";
import { ISearchablePage } from "../../models/props";
import { useState } from "react";
import { MenuItem } from "../../models/menu";
import { AccountOpeningForm } from "../AccountListing/AccountListing";
import Frame from "../../components/controls/Frame/Frame";
import FormModal from "../../components/controls/FormModal";
import FormCommand from "../../components/controls/FormCommand";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
import { MdDelete, MdEdit, MdOpenInNew } from "react-icons/md";

export interface CustomerListingProps extends ISearchablePage<Customer> {
  isModal?: boolean;
}

export const CustomerListing: React.FunctionComponent<CustomerListingProps> = (
  props: CustomerListingProps
) => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [customer, setCustomer] = useState<Customer>();
  const [showAccountOpeningForm, setShowAccountOpeningForm] = useState(false);

  const customerMenu: MenuItem<Customer>[] = [
    new MenuItem(
      "Edit",
      function (e: Customer) {
        setCustomer(e);
      },
      <MdEdit />
    ),
    new MenuItem(
      "Deleted",
      function (e: Customer) {
        const ans = window.confirm(
          "Are you sure you want to delete this customer record?"
        );
        if (!ans) return;

        const deleteCustomerAsync = async () => {
          const res = await customerService.deleteCustomer(e.id ?? 0);
          alert(res.message);
          if (res.status) {
            setCustomers(customers.filter((d) => d.id !== e.id));
          }
        };

        deleteCustomerAsync();
      },
      <MdDelete />
    ),
    new MenuItem(
      "Open Account",
      function (e: Customer) {
        setShowAccountOpeningForm(true);
      },
      <MdOpenInNew />
    ),
  ];

  return (
    <div className="row">
      <div className="col">
        <Frame>
          <h4>Customers</h4>

          <GridView
            name={"lstAccountOfficers"}
            context="Customers"
            onRecordSelected={props.onSelected}
            showSearchBar={true}
            showAddButton={true}
            onAddRecord={() => setCustomer({})}
          >
            <GridView.Header>
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>Action(s)</th>
                </tr>
              </thead>
            </GridView.Header>
            <GridView.Content>
              {customers.map((item) => (
                <tr>
                  <td>{item.customerName}</td>
                  <td>{item.phoneNo}</td>
                  <td>{item.emailAddress}</td>
                  <td>
                    <ContextMenu<Customer> menu={customerMenu} item={item} />
                  </td>
                </tr>
              ))}
            </GridView.Content>
          </GridView>

          {showAccountOpeningForm && (
            <FormModal onClose={() => setShowAccountOpeningForm(false)}>
              <AccountOpeningForm
                customer={customer}
                onSave={async (account) => {
                  console.log(
                    `Account opened for customer ${customer?.id} ${account.name}`
                  );
                }}
              />
            </FormModal>
          )}

          {customer && (
            <FormModal
              onClose={() => setCustomer(undefined)}
              title="Customer Profile"
            >
              <CustomerRegistrationForm customer={customer} />
            </FormModal>
          )}
        </Frame>
      </div>
    </div>
  );
};

export interface CustomerRegistrationFormProps {
  customer: Customer;
  onCustomerSaved?: (customer: Customer) => void;
}

export function CustomerRegistrationForm(props: CustomerRegistrationFormProps) {
  const [customer, setCustomer] = useState(props.customer);
  const [disableCustomerNameField, setDisableCustomerNameField] =
    useState(true);

  const saveCustomerAsync = async () => {
    if (customer === undefined) return;

    const res = await customerService.createOrUpdateCustomer(customer);
    alert(res.message);
    if (res.status && customer !== undefined) {
      props.onCustomerSaved?.(customer);
    }
  };

  return (
    <div className="row">
      <div className="col">
        <div className="row">
          <div className="col">
            <label htmlFor="customerFirstName" className="control-label">
              First Name
            </label>
            <input
              type="text"
              name="customerFirstName"
              id="customerFirstName"
              className="form-control form-control-sm"
              value={customer.firstName}
              onChange={(e) => {
                setCustomer({ ...customer, firstName: e.currentTarget.value });
                setDisableCustomerNameField(e.currentTarget.value.length > 0);
              }}
            />
          </div>
          <div className="col">
            <label htmlFor="customerLastName" className="control-label">
              Last Name
            </label>
            <input
              type="text"
              name="customerLastName"
              id="customerLastName"
              className="form-control form-control-sm"
              value={customer.lastName}
              onChange={(e) =>
                setCustomer({ ...customer, lastName: e.currentTarget.value })
              }
            />
          </div>

          <div className="col">
            <label htmlFor="otherName" className="control-label">
              Other Name(s)
            </label>
            <input
              type="text"
              name="otherName"
              id="otherName"
              className="form-control form-control-sm"
              value={customer.otherName}
              onChange={(e) =>
                setCustomer({ ...customer, otherName: e.currentTarget.value })
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="customerOtherName" className="control-label">
              Customer Name
            </label>
            <input
              type="text"
              name="customerOtherName"
              id="customerOtherName"
              className="form-control form-control-sm"
              value={customer.otherName}
              disabled={disableCustomerNameField}
              onChange={(e) =>
                setCustomer({ ...customer, otherName: e.currentTarget.value })
              }
            />
          </div>
        </div>

        {/* <div className="row">
                    <div className="col">
                        <label htmlFor="bvn" className='control-label'>BVN</label>
                        <input type="text" name="bvn" id="bvn" className='form-control form-control-sm'
                            value={customer.bvn}
                            onChange={(e) => setCustomer({ ...customer, bvn: e.currentTarget.value })} />
                    </div>
                    <div className="col">
                        <label htmlFor="IntlPassport" className='control-label'>IntlPassport</label>
                        <input type="text" name="IntlPassport" id="IntlPassport" className='form-control form-control-sm'
                            value={customer.intlPassportNo}
                            onChange={(e) => setCustomer({ ...customer, intlPassportNo: e.currentTarget.value })} />
                    </div>
                    <div className="col">
                        <label htmlFor="driverLicense" className='control-label'>Driver License</label>
                        <input type="text" name="driverLicense" id="driverLicense"
                            className='form-control form-control-sm'
                            value={customer.driversLicense}
                            onChange={(e) => setCustomer({ ...customer, driversLicense: e.currentTarget.value })}
                        />
                    </div>
                    <div className="col">
                        <label htmlFor="votersId" className='control-label'>Voter ID</label>
                        <input type="text" name="votersId" id="votersId"
                            className='form-control form-control-sm'
                            value={customer.votersId}
                            onChange={(e) => setCustomer({ ...customer, votersId: e.currentTarget.value })}
                        />
                    </div>
                </div> */}

        <div className="row">
          <div className="col">
            <label htmlFor="email" className="control-label">
              Email
            </label>
            <input
              type="text"
              name="email"
              id="email"
              className="form-control form-control-sm"
              value={customer.emailAddress}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  emailAddress: e.currentTarget.value,
                })
              }
            />
          </div>
          <div className="col">
            <label htmlFor="phoneNo" className="control-label">
              Phone No
            </label>
            <input
              type="text"
              name="phoneNo"
              id="phoneNo"
              className="form-control form-control-sm"
              value={customer.phoneNo}
              onChange={(e) =>
                setCustomer({ ...customer, phoneNo: e.currentTarget.value })
              }
            />
          </div>
          <div className="col">
            <label htmlFor="gender" className="control-label">
              Gender
            </label>
            <select
              className="form-control form-control-sm"
              name="gender"
              id="gender"
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  gender: Number(e.currentTarget.value),
                })
              }
              value={customer.gender}
            >
              <option value="">Select Gender</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>
          </div>
        </div>
        <div className="row">
          {/* <div className="col-3">
                        <label htmlFor="nationlity" className='control-label'>Nationality</label>
                        <select className='form-control form-control-sm'
                            name='nationality' title='Select Country'
                            value={customer.nationalityId}
                            onChange={(e) => setCustomer({ ...customer, nationalityId: Number(e.currentTarget.value) })}>
                            <option value="" >Select Country</option>
                            <option value="NG">Nigeria</option>
                        </select>
                    </div> */}
          <div className="col-6">
            <label htmlFor="officeAddress" className="control-label">
              Office Address
            </label>
            <textarea
              name="officeAddress"
              id="officeAddress"
              className="form-control form-control-sm"
              value={customer.officeAddress}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  officeAddress: e.currentTarget.value,
                })
              }
            ></textarea>
          </div>
          <div className="col-6">
            <label htmlFor="residentialAddress" className="control-label">
              Residential Address
            </label>
            <textarea
              name="residentialAddress"
              id="residentialAddress"
              className="form-control form-control-sm"
              value={customer.residentialAddress}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  residentialAddress: e.currentTarget.value,
                })
              }
            ></textarea>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <label htmlFor="religion" className="control-label">
              Religion
            </label>
            <select
              className="form-control form-control-sm"
              name="nationality"
              id="nationality"
              title="Select Country"
              value={customer.religionId}
              onChange={(e) =>
                setCustomer({ ...customer, religionId: e.currentTarget.value })
              }
            >
              <option value="">Select Religion</option>
              <option value="1">Christian</option>
              <option value="2">Muslim</option>
            </select>
          </div>
          <div className="col">
            <label htmlFor="maritalStatus" className="control-label">
              Marital Status
            </label>
            <select
              className="form-control form-control-sm"
              name="maritalStatus"
              id="maritalStatus"
              title="Select Marital Status"
              value={customer.maritalStatus}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  maritalStatus: Number(e.currentTarget.value),
                })
              }
            >
              <option value="">Select Marital Status</option>
              <option value="1">Single</option>
              <option value="2">Married</option>
              <option value="3">Divorced</option>
              <option value="3">Windowed</option>
            </select>
          </div>

          <div className="col">
            <label htmlFor="placeOfBirth" className="control-label">
              Place of Birth
            </label>
            <input
              type="text"
              name="placeOfBirth"
              id="placeOfBirth"
              className="form-control form-control-sm"
              value={customer.placeOfBirth}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  placeOfBirth: e.currentTarget.value,
                })
              }
            />
          </div>
          <div className="col">
            <label htmlFor="mothersMaidenName" className="control-label">
              Mother's Maiden Name
            </label>
            <input
              type="text"
              name="mothersMaidenName"
              id="mothersMaidenName"
              className="form-control form-control-sm"
              value={customer.mothersMaidenName}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  mothersMaidenName: e.currentTarget.value,
                })
              }
            />
          </div>
        </div>

        <FormCommand />
      </div>
    </div>
  );
}
